<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" class="currentTab" type="border-card">
      <el-tab-pane :key="'first'" label="单据信息" name="first">
        <childTab1 ref="childTab1" @isShow="isShow" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import editMain from '@/views/PurcManagement/FinishedProductAndMaterialOrder/TabChild/EditMain.vue';

export default {
  name: 'FinishedProductAndMaterialOrderEdit',
  components: {
    childTab1: editMain
  },
  data() {
    return {
      activeName: 'first',
      isSho: true
    };
  },
  created() {},
  methods: {
    isShow(val) {
      this.isSho = val;
    },
    draftState() {
      this.$refs.childTab1.initData();
    }
  }
};
</script>

<style lang="scss" scoped>
.currentTab > ::v-deep .el-tabs__content {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding-top: 0;
}
</style>
